import { connect } from 'datocms-plugin-sdk';
import { render } from 'src/utils/render';
import ConfigScreen from 'src/entrypoints/ConfigScreen';
import FieldExtension from 'src/entrypoints/FieldExtension'
import 'datocms-react-ui/styles.css';

connect({
  renderConfigScreen(ctx) {
    return render(<ConfigScreen ctx={ctx} />);
  },
  manualFieldExtensions() {
    return [
      {
        id: 'table',
        type: 'editor',
        name: 'HTML Table Editor',
        fieldTypes: ['json'],
      },
    ]
  },
  renderFieldExtension(id, ctx) {
    render(<FieldExtension ctx={ctx} />)
  },
});
